<div
  [ngClass]="['text-white px-6 py-4 border-0 rounded absolute right-0 top-0 mt-10 mr-10', 'bg-'+alert?.color+'-500']"
  >
  <span class="inline-block align-middle font-semibold mr-8"> {{alert?.message}} </span>
  <button
    class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none"
  >
    <span>×</span>
  </button>
</div>
